import { HTTP } from '../http.js'

const auth = {
    getMe() {
        return HTTP.get('/me')
            .then(response => {
                return Promise.resolve(response.data);
            })
        ;
    },

    login(post_data) {
        return HTTP.post('/session', post_data)
            .then(response => {
                return Promise.resolve(response.data);
            })
        ;
    },

    logout() {
        return HTTP.delete('/session');
    }
};

export default auth;
